import { Skeleton, SubPartnerAccount, withStyles } from 'vopay';
import { BodyText } from 'UI';
import { Permissions } from 'shared/permissions';
import usePartnerPermissionSections from '@/components/Partners/PartnerManagement/usePartnerPermissionSections';
import styles from './PartnerPermissionsTab.module.scss';

const cn = withStyles(styles);

type PartnerPermissionsTabProps = {
  partner: SubPartnerAccount;
};

/**
 * The partner page's Permissions tab (spec 5.6.2): the partner account's payment-rail toggles in the
 * account Permissions tab's layout — the same tree the list's Partner Permissions drawer shows. Always
 * read-only: a parent partner cannot change them, so there is no Enable All and no Save, only the search.
 */
export default function PartnerPermissionsTab({ partner }: PartnerPermissionsTabProps) {
  const { sections, isLoading, message } = usePartnerPermissionSections(partner.PartnerAccountID, true);

  return (
    // Read-only: there is no Save, so onSave never runs.
    <Permissions
      sections={sections}
      currency={partner.Currency}
      readOnly
      formID="partnerPermissionsTabForm"
      onSave={() => undefined}
    >
      <div className={cn('tab')} data-testid="partnerPermissionsTab">
        {/* As on the account Permissions tab (ID-13981), minus Enable All / Save: the search fills the row. */}
        <div className={cn('toolbar')} data-testid="partnerPermissionsToolbar">
          <Permissions.Search />
        </div>

        {isLoading && <Skeleton height={320} data-testid="partnerPermissionsSkeleton" />}
        {!isLoading && (message ? <BodyText className={cn('message')}>{message}</BodyText> : <Permissions.Sections />)}
      </div>
    </Permissions>
  );
}
